import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/primaveras/f9.png'
import _imports_1 from '../../assets/images/primaveras/f7.png'
import _imports_2 from '../../assets/images/primaveras/f3.png'


const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "footer"
}
const _hoisted_3 = { class: "foot-cols" }
const _hoisted_4 = { class: "foot-col" }
const _hoisted_5 = { class: "foot-h" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "foot-link-group" }
const _hoisted_8 = {
  class: "foot-link",
  href: "https://www.legacyfuneral.com.br/quem-somos/",
  target: "_blank"
}
const _hoisted_9 = {
  class: "foot-link",
  href: "https://www.legacyfuneral.com.br/seja-parceiro/",
  target: "_blank"
}
const _hoisted_10 = {
  class: "foot-link",
  href: "https://www.legacyfuneral.com.br/seja-parceiro-hospitais/",
  target: "_blank"
}
const _hoisted_11 = { class: "foot-h" }
const _hoisted_12 = {
  class: "foot-link",
  href: "https://www.legacyfuneral.com.br/ouvidoria/",
  target: "_blank"
}
const _hoisted_13 = { class: "foot-col" }
const _hoisted_14 = { class: "foot-h" }
const _hoisted_15 = { class: "foot-note" }
const _hoisted_16 = {
  class: "foot-tel-row",
  href: "tel:08000001878"
}
const _hoisted_17 = { class: "foot-col" }
const _hoisted_18 = { class: "foot-h" }
const _hoisted_19 = { class: "foot-socials" }
const _hoisted_20 = {
  class: "foot-social",
  href: "https://www.facebook.com/legacyfuneralbr",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_21 = {
  class: "foot-social",
  href: "https://www.instagram.com/legacy.funeral/",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_22 = {
  class: "foot-social",
  href: "https://www.linkedin.com/company/legacyfuneral/",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_23 = { class: "foot-copy" }
const _hoisted_24 = { class: "project-current-version" }
const _hoisted_25 = {
  key: 1,
  class: "primaveras-footer"
}
const _hoisted_26 = { class: "box-2" }
const _hoisted_27 = {
  class: "row no-gutters",
  id: "row1"
}
const _hoisted_28 = { class: "col-12 col-md-5" }
const _hoisted_29 = {
  "aria-label": "menu secundario",
  class: "navigation",
  id: "footer-navigation"
}
const _hoisted_30 = { class: "footer-navigation" }
const _hoisted_31 = { id: "work-with-us" }
const _hoisted_32 = { class: "box-3" }
const _hoisted_33 = { class: "row align-items-center justify-content-end flex-column-reverse flex-md-row" }
const _hoisted_34 = { class: "col-12 col-md-5 d-flex align-items-center justify-content-end" }
const _hoisted_35 = { href: "https://www.youtube.com/channel/UCzHyw7zWxXZXlvWX6ZgGpBQ" }
const _hoisted_36 = { href: "https://www.facebook.com/grupoprimaveras/" }
const _hoisted_37 = { href: "https://instagram.com/grupoprimaveras" }
const _hoisted_38 = { href: "https://api.whatsapp.com/send?phone=551124048900" }
const _hoisted_39 = { href: "tel:+1124048900" }

export function render(_ctx, _cache) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")
  const _component_router_view = _resolveComponent("router-view")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_legacy_icon = _resolveComponent("legacy-icon")
  const _component_Modal = _resolveComponent("Modal")
  const _component_CopyrightTermsModal = _resolveComponent("CopyrightTermsModal")
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[26] || (_cache[26] = _createStaticVNode("<div style=\"height:0;\" data-v-10fff8dc><svg width=\"0\" height=\"0\" viewBox=\"0 0 16 16\" data-v-10fff8dc><defs data-v-10fff8dc><clipPath id=\"marker\" clipPathUnits=\"objectBoundingBox\" transform=\"scale(0.0625 0.0625)\" data-v-10fff8dc><path d=\"M 0 0.8 v 9 c 0 0.4 0.3 1 0.8 1.3 l 6.5 4.4 c 0.4 0.3 1.1 0.3 1.5 0 l 6.5 -4.4 c 0.4 -0.3 0.8 -0.9 0.8 -1.3 v -9 L 16.1 0 H 0 z\" data-v-10fff8dc></path></clipPath></defs><defs data-v-10fff8dc><linearGradient id=\"golden-gradient\" data-v-10fff8dc><stop offset=\"5%\" stop-color=\"#462878\" data-v-10fff8dc></stop><stop offset=\"95%\" stop-color=\"#f2ecb6\" data-v-10fff8dc></stop></linearGradient></defs></svg></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_HeaderComponent, {
        sidebarVisible: _ctx.sidebarVisible,
        "onUpdate:sidebarVisible": _cache[0] || (_cache[0] = $event => ((_ctx.sidebarVisible) = $event))
      }, null, 8, ["sidebarVisible"]),
      _createElementVNode("div", {
        id: "page-container",
        class: _normalizeClass(["body", {'solid-bg': _ctx.solidBackground}]),
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.closeSidebar()))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["router-container main-container-min-width", {'no-spacing-top': !_ctx.spacingTop,'no-spacing-bottom': _ctx.noSpacingBottom, 'full-width': _ctx.fullWidth}])
        }, [
          _createVNode(_component_router_view)
        ], 2)
      ], 2)
    ]),
    (this.$store.getters.getStyleMode !== 'primaveras')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "foot-rule" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "foot-col-rule" }, null, -1)),
              _createElementVNode("h2", _hoisted_5, [
                _createElementVNode("img", {
                  class: "foot-col-logo",
                  src: require('@/assets/svg/logo_brand.svg'),
                  alt: "Legacy Funeral"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('aboutUs')), 1),
                _createElementVNode("a", {
                  class: "foot-link",
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.openCopyrightTermsModal()))
                }, _toDisplayString(_ctx.$t('privacyAndSecurity')), 1),
                _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('funeralPartner')), 1),
                _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('hospitalPartner')), 1)
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("span", {
                class: "foot-col-rule",
                style: {"margin-top":"24px"}
              }, null, -1)),
              _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('help')), 1),
              _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('support')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "foot-col-rule" }, null, -1)),
              _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('contact')), 1),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('contactDescription')), 1),
              _createElementVNode("a", _hoisted_16, [
                _createVNode(_component_fa_icon, {
                  icon: ['fa', 'phone'],
                  class: "foot-ic"
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "foot-tel" }, "0800 000 1878", -1))
              ]),
              _createElementVNode("a", {
                class: "foot-cta",
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.openRDForm && _ctx.openRDForm(...args)), ["prevent"]))
              }, [
                _createVNode(_component_fa_icon, {
                  icon: ['fab', 'whatsapp'],
                  class: "foot-cta-icon"
                }),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Entre em contato!", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "foot-col-rule" }, null, -1)),
              _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.$t('socialNetworks')), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", _hoisted_20, [
                  _createVNode(_component_fa_icon, { icon: ['fab', 'facebook-f'] })
                ]),
                _createElementVNode("a", _hoisted_21, [
                  _createVNode(_component_fa_icon, { icon: ['fab', 'instagram'] })
                ]),
                _createElementVNode("a", _hoisted_22, [
                  _createVNode(_component_fa_icon, { icon: ['fab', 'linkedin-in'] })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", null, "©Copyright " + _toDisplayString(new Date().getFullYear()) + ". Todos os direitos reservados. LEGACY  |  CNPJ 37.198.111/0001-64  ", 1),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.openCopyrightTermsModal()))
            }, _toDisplayString(_ctx.$t('copyrightTerms')), 1),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.currentProjectVersion), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "box-1 d-flex justify-content-center align-items-center" }, [
            _createElementVNode("p", { class: "text-center m-0" }, [
              _createElementVNode("b", null, [
                _createTextVNode(" Se você é um associado do Plano de Assistência Funeral Primaveras, ligue para "),
                _createElementVNode("a", { href: "tel:1124048900" }, "(11) 2404-8900"),
                _createTextVNode(" e receba todas as orientações de forma personalizada. ")
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("nav", _hoisted_29, [
                  _createElementVNode("ul", _hoisted_30, [
                    _cache[18] || (_cache[18] = _createElementVNode("li", {
                      class: "menu-item",
                      id: "location"
                    }, [
                      _createElementVNode("a", { href: "https://www.primaveras.com.br/onde/" }, [
                        _createElementVNode("span", null, "Onde Estamos")
                      ])
                    ], -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("li", {
                      class: "menu-item",
                      id: "contact-us"
                    }, [
                      _createElementVNode("a", { href: "https://www.primaveras.com.br/fale-conosco/" }, [
                        _createElementVNode("span", null, "Fale-conosco")
                      ])
                    ], -1)),
                    _createElementVNode("li", {
                      class: "menu-item",
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.toggleWorkUs()))
                    }, _cache[17] || (_cache[17] = [
                      _createElementVNode("a", null, [
                        _createElementVNode("span", null, "Trabalhe Conosco")
                      ], -1)
                    ])),
                    _cache[20] || (_cache[20] = _createStaticVNode("<li class=\"menu-item\" data-v-10fff8dc><a href=\"https://cx-primaveras.ultrai.net/\" data-v-10fff8dc><span data-v-10fff8dc>2ª via do boleto</span></a></li><li class=\"menu-item\" data-v-10fff8dc><a href=\"https://www.primaveras.com.br/sobre-nos/\" data-v-10fff8dc><span data-v-10fff8dc>Sobre nós</span></a></li><li class=\"menu-item\" data-v-10fff8dc><a rel=\"privacy-policy\" href=\"https://www.primaveras.com.br/politica-de-privacidade/\" data-v-10fff8dc><span data-v-10fff8dc>Política de privacidade</span></a></li>", 3))
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close-button",
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.toggleWorkUs()))
                  }, "X"),
                  _cache[21] || (_cache[21] = _createElementVNode("h6", null, "Trabalhe Conosco", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", null, [
                    _createTextVNode(" Por favor, caso tenha interesse em fazer parte do time Primaveras, envie seu currículo para "),
                    _createElementVNode("a", {
                      href: "mailto:recrutamento@primaveras.com.br",
                      class: "mail"
                    }, "recrutamento@primaveras.com.br")
                  ], -1))
                ])
              ]),
              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"col-12 col-md-7\" data-v-10fff8dc><div class=\"row\" data-v-10fff8dc><div class=\"col-12 col-md-4\" data-v-10fff8dc><address data-v-10fff8dc><img src=\"" + _imports_0 + "\" alt=\"imagem flor\" class=\"flower\" data-v-10fff8dc><br data-v-10fff8dc><a href=\"https://www.google.com/maps/place/Av.+Ot%C3%A1vio+Braga+de+Mesquita,+3535+-+Jardim+Sao+Geraldo,+Guarulhos+-+SP,+07191-000/@-23.4343983,-46.5057613,19z/data=!3m1!4b1!4m5!3m4!1s0x94ce8adaf5f5a511:0x164b74c243fe37a8!8m2!3d-23.4343983!4d-46.5052141\" target=\"_blank\" data-v-10fff8dc><span class=\"name\" data-v-10fff8dc>PRIMAVERAS P1</span><br data-v-10fff8dc><span class=\"street\" data-v-10fff8dc>Av. Otávio Braga de Mesquita</span> , <span class=\"number\" data-v-10fff8dc>3535</span>, <span class=\"neighborhood\" data-v-10fff8dc>Taboão</span>, <br data-v-10fff8dc><span class=\"city\" data-v-10fff8dc>Guarulhos </span><span class=\"region\" data-v-10fff8dc>SP</span><br data-v-10fff8dc><a href=\"tel:+1124048900\" class=\"tel\" data-v-10fff8dc>Tel.: 11 2404-8900</a></a></address></div><div class=\"col-12 col-md-4\" data-v-10fff8dc><address data-v-10fff8dc><img src=\"" + _imports_1 + "\" alt=\"imagem flor\" class=\"flower\" data-v-10fff8dc><br data-v-10fff8dc><a href=\"https://www.google.com/maps?sll=-23.417872,-46.507106&amp;q=Av.+Silvestre+Pires+de+Freitas,+1579,+Para%C3%ADso,+Guarulhos+SP+SP,+07141-040,+Brasil&amp;z=12\" target=\"_blank\" data-v-10fff8dc><span class=\"name\" data-v-10fff8dc>PRIMAVERAS P2</span><br data-v-10fff8dc><span class=\"street\" data-v-10fff8dc>Av. Silvestre Pires de Freitas</span> , <span class=\"number\" data-v-10fff8dc>1579</span>, <span class=\"neighborhood\" data-v-10fff8dc>Paraíso</span>, <br data-v-10fff8dc><span class=\"city\" data-v-10fff8dc>Guarulhos </span><span class=\"region\" data-v-10fff8dc>SP</span><br data-v-10fff8dc><a href=\"tel:+1120884230\" class=\"tel\" data-v-10fff8dc>Tel.: 11 2088-4230</a></a></address></div><div class=\"col-12 col-md-4\" data-v-10fff8dc><address data-v-10fff8dc><img src=\"" + _imports_2 + "\" alt=\"imagem flor\" class=\"flower\" data-v-10fff8dc><br data-v-10fff8dc><a href=\"https://www.google.com/maps/place/R.+Luiz+Gama,+185+-+Centro,+Guarulhos+-+SP,+07010-050/@-23.468384,-46.531018,17z/data=!3m1!4b1!4m5!3m4!1s0x94cef55bd0b87913:0x9898d97ecf2840ae!8m2!3d-23.468384!4d-46.5288293\" target=\"_blank\" data-v-10fff8dc><span class=\"name\" data-v-10fff8dc>PRIMAVERAS ESSENCIAL</span><br data-v-10fff8dc><span class=\"street\" data-v-10fff8dc>Rua Luís Gama</span> , <span class=\"number\" data-v-10fff8dc>185</span>, <span class=\"neighborhood\" data-v-10fff8dc>Centro</span>, <br data-v-10fff8dc><span class=\"city\" data-v-10fff8dc>Guarulhos </span><span class=\"region\" data-v-10fff8dc>SP</span><br data-v-10fff8dc><a href=\"tel:+1120500200\" class=\"tel\" data-v-10fff8dc>Tel.: 11 2050-0200</a></a></address></div></div></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-12 col-md-7" }, [
                _createElementVNode("p", { class: "text-footer" }, " Nossa vocação é trazer amor e luz ao desconhecido na morte, oferecendo acolhimento, respeito, dignidade e esperança à família enlutada, à sociedade e à vida. ")
              ], -1)),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("a", _hoisted_35, [
                  _createVNode(_component_legacy_icon, {
                    class: "footer-icon",
                    icon: "primaveras/youtube",
                    "is-svg": true
                  })
                ]),
                _createElementVNode("a", _hoisted_36, [
                  _createVNode(_component_legacy_icon, {
                    class: "footer-icon",
                    icon: "primaveras/face",
                    "is-svg": true
                  })
                ]),
                _createElementVNode("a", _hoisted_37, [
                  _createVNode(_component_legacy_icon, {
                    class: "footer-icon",
                    icon: "primaveras/insta",
                    "is-svg": true
                  })
                ]),
                _createElementVNode("a", _hoisted_38, [
                  _createVNode(_component_legacy_icon, {
                    class: "footer-icon",
                    icon: "primaveras/whats-footer",
                    "is-svg": true
                  })
                ]),
                _createElementVNode("a", _hoisted_39, [
                  _createVNode(_component_legacy_icon, {
                    class: "footer-icon tel-24h",
                    icon: "primaveras/phone-24h-footer",
                    "is-svg": true
                  })
                ])
              ])
            ])
          ])
        ])),
    _createVNode(_component_Modal, {
      "golden-title": "true",
      class: "contact-modal",
      title: _ctx.modalTitle,
      description: _ctx.modalDescription,
      show: _ctx.modalVisible,
      "onUpdate:show": _cache[7] || (_cache[7] = $event => ((_ctx.modalVisible) = $event))
    }, null, 8, ["title", "description", "show"]),
    _createVNode(_component_CopyrightTermsModal, {
      show: _ctx.showCopyrightTermsModal,
      "onUpdate:show": _cache[8] || (_cache[8] = $event => ((_ctx.showCopyrightTermsModal) = $event))
    }, null, 8, ["show"]),
    _createVNode(_component_Loading, {
      active: this.$store.getters.getShowFullLoad,
      "onUpdate:active": _cache[9] || (_cache[9] = $event => ((this.$store.getters.getShowFullLoad) = $event)),
      tabindex: "-1",
      "can-cancel": false,
      color: "#ff9100",
      backgroundColor: "white",
      opacity: 1,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}